<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="ch00_fm04_title"><a id="page_iii"></a>The Heart <span class="underline">of</span> Leadership</h1>
<p class="subtitle">Becoming a Leader People<br/>Want to Follow</p>
<p class="author"><strong>Mark Miller</strong></p>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04_title.vue?433b9eea